import React from 'react';
import { formValues } from 'redux-form';
import Moment from 'moment';

const fieldsMapping = {
  startDate: 'start_date',
  startTime: 'start_time',
  endTime: 'end_time',
};

const EventLengthCalculator = formValues(fieldsMapping)((props) => {
  if (!props.endTime || !props.startTime) { return null; }

  const startTime = Moment(props.startTime, 'HH:mm');
  const endTime = Moment(props.endTime, 'HH:mm');

  if (endTime.isAfter(startTime)) { return null; }

  const eventLength = startTime.diff(endTime.add(1, 'd'), 'hours');

  if (isNaN(eventLength)) {
    return null;
  }

  return (
    <span>Event length: {Math.abs(eventLength)} hours</span>
  );
});

export default EventLengthCalculator;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/EventLengthCalculator.jsx